var DialogView = require('dialogview');

var scriptjs = require('scriptjs');

var EmailBounceView = DialogView.extend({
    el: '.emailBounce',
    initialize: function (options) {
        this.email = this.$('.emailBounce__email');
        this.reason = this.$('.emailBounce__reason');
        this.time = this.$('.emailBounce__time');
        this.details = this.$('.emailBounce__details');

        this.listenTo(this.model, 'change:email', this.emailChange);

        DialogView.prototype.initialize.apply(this, arguments);
    },

    emailChange: function () {
        this.checkPostmarkRebound();
    },
    loadPostmarkRebound: function () {
        // https://postmarkapp.com/rebound
        window.ReboundSettings = {
            publicToken: window.IRCConfig.postmark_rebound_public_key,
            email: this.model.get('email'),
            appearance: "custom",
            // Set unused options to 0 to minimise network traffic
            actionUrl: 0,
            actionLabel: 0,
            description: 0,
            title: 0,
            position: 0,
            color: 0,
            repeat: 0,
            complete: _.bind(this.postmarkReboundComplete, this),
        };
        if (this._loadPostmarkRebound) {
            return false;
        }
        this._loadPostmarkRebound = true;
        scriptjs([
            "https://rebound.postmarkapp.com/widget/1.0"
        ], function () {
            if (window.Rebound) {
                scriptjs.done('rebound');
            }
        });
        return true;
    },
    checkPostmarkRebound: function () {
        if (!this.loadPostmarkRebound()) {
            scriptjs.ready('rebound', _.bind(function () {
                window.Rebound.check(window.ReboundSettings);
            }, this));
        }
    },
    postmarkReboundComplete: function (response) {
        if (response.inactive) {
            this.email.text(response.data.email);
            this.reason.text(response.data.reason);
            this.time.text(response.data.time);
            this.details.text(response.data.details);
            this.show();
        }
    }
});


module.exports = EmailBounceView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/emailbounceview.js
// module id = 99PH
// module chunks = 1